import { render } from "./PassengerModal.vue?vue&type=template&id=f231b0da"
import script from "./PassengerModal.vue?vue&type=script&lang=js"
export * from "./PassengerModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__